import ApiService from "@/services/api.service";

import Vue from "vue";

const route = "charges";

const charges = {
  contacts(_module) {
    return new Promise((resolve, reject) => {
      const params = Object.assign({}, _module);
      ApiService.post(route + "/contacts", params).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  sendSlips(_module) {
    return new Promise((resolve, reject) => {
      const params = Object.assign({}, _module);
      ApiService.post(route + "/send_slips", params).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  salesmanEvaluations(_module) {
    return new Promise((resolve, reject) => {
      const params = Object.assign({}, _module);
      ApiService.post(route + "/salesman_evaluations", params).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  Evaluation(_id) {
    return new Promise((resolve, reject) => {
      ApiService.get("evaluation/" + _id).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  all(_limit, page, _params) {
    return new Promise((resolve, reject) => {
      var params = "?limit=" + _limit + "&page=" + page;

      if (_params.reference_date != null) {
        params += "&reference_date=" + _params.reference_date;
      }

      params += "&init_at=" + _params.init_at;
      params += "&end_at=" + _params.end_at;

      if (_params.due_init_at != null && _params.due_end_at != null) {
        params += "&due_init_at=" + _params.due_init_at;
        params += "&due_end_at=" + _params.due_end_at;
      }


      if (_params.status != null) {
        params += "&status=" + _params.status;
      }

      if (_params.branch_id != null) {
        params += "&branch_id=" + _params.branch_id;
      }

      if (_params.administrator_id != null) {
        params += "&administrator_id=" + _params.administrator_id;
      }

      if (_params.group_id != null) {
        params += "&group_id=" + _params.group_id;
      }

      if (_params.installment != null) {
        params += "&installment=" + _params.installment;
      }

      if (_params.next_contact_at != null) {
        params += "&next_contact_at=" + Vue.moment(_params.next_contact_at).format('YYYY-MM-DD');
      }

      if (_params.physical_proposal != null)
        params += "&physical_proposal=" + _params.physical_proposal;

      if (_params.client_name != null)
        params += "&client_name=" + _params.client_name;

      ApiService.get(route + params).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  get(_id) {
    return new Promise((resolve, reject) => {
      ApiService.get(route + "/" + _id).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  add(_module) {
    return new Promise((resolve, reject) => {
      const params = Object.assign({}, _module);

      if (
        params.proposal.sale_at != undefined &&
        params.proposal.sale_at != ""
      ) {
        params.proposal.sale_at = Vue.moment(params.proposal.sale_at).format(
          "YYYY-MM-DD"
        );
      }

      if (
        params.proposal.meeting_at != undefined &&
        params.proposal.meeting_at != ""
      ) {
        params.proposal.meeting_at = Vue.moment(
          params.proposal.meeting_at
        ).format("YYYY-MM-DD");
      }

      ApiService.post(route, params).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  edit(_id, _module) {
    return new Promise((resolve, reject) => {
      const params = Object.assign({}, _module);

      if (params.invoice_at != undefined && params.invoice_at != "") {
        params.invoice_at = Vue.moment(params.invoice_at).format("YYYY-MM-DD");
      }

      if (params.cancel_at != undefined && params.cancel_at != "") {
        params.cancel_at = Vue.moment(params.cancel_at).format("YYYY-MM-DD");
      }

      if (params.contemplate_at != undefined && params.contemplate_at != "") {
        params.contemplate_at = Vue.moment(params.contemplate_at).format(
          "YYYY-MM-DD"
        );
      }

      if (params.contemplate_at != undefined && params.contemplate_at != "") {
        params.contemplate_at = Vue.moment(params.contemplate_at).format(
          "YYYY-MM-DD"
        );
      }

      if (params.in_default_at != undefined && params.in_default_at != "") {
        params.in_default_at = Vue.moment(params.in_default_at).format(
          "YYYY-MM-DD"
        );
      }

      ApiService.patch(route, _id, params).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  rem(_id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(route, _id).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default charges;
